import { ComponentType, lazy } from 'react';

const RELOAD_FLAG = 'chunk-reload-attempted';

export const isChunkLoadError = (error: unknown): boolean => {
  const err = error as { name?: string; message?: string } | null;
  return (
    err?.name === 'ChunkLoadError' || /Loading (CSS )?chunk [\w-]+ failed/i.test(err?.message ?? '')
  );
};

/**
 * Wrapper autour de React.lazy : si le chunk ne peut pas être chargé
 * (ex: nouveau déploiement, ancien index.html en cache), on recharge
 * la page une seule fois pour récupérer la nouvelle version.
 */
const lazyWithRetry = <T extends ComponentType<any>>(factory: () => Promise<{ default: T }>) =>
  lazy(async () => {
    try {
      const module = await factory();
      sessionStorage.removeItem(RELOAD_FLAG);
      return module;
    } catch (error) {
      if (isChunkLoadError(error) && !sessionStorage.getItem(RELOAD_FLAG)) {
        sessionStorage.setItem(RELOAD_FLAG, 'true');
        window.location.reload();
        // On ne résout jamais : la page est en train de se recharger
        return new Promise<{ default: T }>(() => {});
      }
      throw error;
    }
  });

export default lazyWithRetry;
